import assign from 'lodash.assign';
export class Party {
    constructor(init) {
        assign(this, init);
    }
    industryClassificationCode;
    partyIdentification;
    websiteURI;
    endpointID;
    partyName;
    postalAddress;
    contact;
    person;
    serviceProviderParty;
    powerOfAttorneys;
    agentParty;
}
